import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITCYStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTcyRunePriceConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_tcy_stats', timeframe)) as ITCYStats[]
	const series1 = chartData.map((element: ITCYStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.AVG_TCY_PRICE_USD }
	})
	const series2 = chartData.map((element: ITCYStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.AVG_TCY_PRICE_IN_RUNE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'tcy [usd]',
			type: 'line',
			seriesGroup: '[usd]',
			color: 'green',
			unitSymbol: '$'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'tcy [rune]',
			type: 'line',
			seriesGroup: '[ᚱUNE]',
			color: 'orange',
			unitSymbol: 'ᚱ'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const TcyRunePrice = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTcyRunePriceConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="TCY/ᚱUNE"
			chartDesc="Price ratio of TCY to RUNE over time."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="7a055efe-72db-4ee0-b542-d4fa0541c84d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default TcyRunePrice
